module.exports = __webpack_public_path__ + "img/regularModuleIcon.b6344699.svg";